<app-header></app-header>

<div class="custom_scrollbar">
  <div>
    <!-- Hero Section -->

    <section
      class="pt-5 d-table w-100"
      style="background: linear-gradient(180deg, #96c2dd, #ffffff 90%)"
    >
      <div class="container">
        <div
          class="row mt-5 align-items-center position-relative"
          style="z-index: 1; bottom: 4rem"
        >
          <div class="col-lg-6">
            <span class="badge bg-primary-subtle text-primary mb-3">
              <i class="bi bi-house-door"></i> Real Estate
            </span>
            <div class="title-heading text-center text-lg-start">
              <h1
                class="fw-bold mb-3 mt-3"
                style="color: #242335; font-size: 2rem; line-height: 1.4"
              >
                A 24/7 Personal Concierge for Home Purchases
              </h1>
              <p
                class="para-desc mx-auto mx-lg-start mb-0 ms-0"
                style="color: black"
              >
                <strong>ConnectNow</strong> transforms the real estate journey
                by providing instant home recommendations, seamless realtor
                connections, and one-click scheduling for property visits.
              </p>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-6 mt-4 pt-2 mt-lg-0 pt-lg-0">
            <div class="card border-0 shadow rounded ms-lg-4 overflow-hidden">
              <iframe
                class="iframe w-100 rounded"
                width="560"
                height="315"
                src="https://www.youtube-nocookie.com/embed/e1OnUbxnHiw?si=-dnf1VonvC-aa_6v&amp;controls=1&rel=0&loop=1"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>

    <!-- Key Features Section -->
    <!-- Key Features Section -->
    <section id="features" class="py-5">
      <div class="container">
        <div class="text-center mb-5">
          <h2 class="fw-bold">Key Features for Real Estate</h2>
          <p class="text-secondary mb-0">
            Smarter tools that simplify home discovery, realtor collaboration,
            and scheduling.
          </p>
        </div>

        <div class="row g-4">
          <!-- Feature 1 -->
          <div class="col-12 col-md-6">
            <div
              class="d-flex p-4 rounded-4 shadow-sm bg-white h-100 align-items-start"
            >
              <div class="me-3 flex-shrink-0">
                <div class="feature-icon bg-primary text-white">
                  <i class="bi bi-search fs-4"></i>
                </div>
              </div>
              <div>
                <h5 class="fw-bold mb-2">Real-time Home Recommendation</h5>
                <p class="mb-0 text-secondary">
                  Personalized AI-powered listings that instantly match your
                  budget, style, and preferences.
                </p>
              </div>
            </div>
          </div>

          <!-- Feature 2 -->
          <div class="col-12 col-md-6">
            <div
              class="d-flex p-4 rounded-4 shadow-sm bg-white h-100 align-items-start"
            >
              <div class="me-3 flex-shrink-0">
                <div class="feature-icon bg-success text-white">
                  <i class="bi bi-camera-video fs-4"></i>
                </div>
              </div>
              <div>
                <h5 class="fw-bold mb-2">Virtual House Visits</h5>
                <p class="mb-0 text-secondary">
                  Join immersive 360° virtual tours with your realtor via video
                  or phone.
                </p>
              </div>
            </div>
          </div>

          <!-- Feature 3 -->
          <div class="col-12 col-md-6">
            <div
              class="d-flex p-4 rounded-4 shadow-sm bg-white h-100 align-items-start"
            >
              <div class="me-3 flex-shrink-0">
                <div class="feature-icon bg-warning text-dark">
                  <i class="bi bi-calendar-check fs-4"></i>
                </div>
              </div>
              <div>
                <h5 class="fw-bold mb-2">One-Click Appointment Scheduling</h5>
                <p class="mb-0 text-secondary">
                  Book property site visits instantly and keep appointments
                  organized effortlessly.
                </p>
              </div>
            </div>
          </div>

          <!-- Feature 4 (New) -->
          <div class="col-12 col-md-6">
            <div
              class="d-flex p-4 rounded-4 shadow-sm bg-white h-100 align-items-start"
            >
              <div class="me-3 flex-shrink-0">
                <div class="feature-icon bg-info text-white">
                  <i class="bi bi-file-earmark-lock fs-4"></i>
                </div>
              </div>
              <div>
                <h5 class="fw-bold mb-2">Secure Document Sharing</h5>
                <p class="mb-0 text-secondary">
                  Safely exchange contracts, agreements, and documents with
                  encrypted, easy-to-access file sharing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>

 <app-footer></app-footer>
  <div class="fix-ui">
    <app-fixed-call></app-fixed-call>
  </div>
</div>
